import { NgModule } from '@angular/core';
import { PushPipe } from './push.pipe';

@NgModule({
  exports: [ PushPipe ],
  declarations: [ PushPipe ]
})
export class PushPipeModule { }
